/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import General from '../../../../public/assets/images/icons/General.png';
import Health from '../../../../public/assets/images/icons/Health.png';
import Work from '../../../../public/assets/images/icons/Work.png';
import Parents from '../../../../public/assets/images/icons/Parent.png';
import Births from '../../../../public/assets/images/icons/Births.png';
import Graduation from '../../../../public/assets/images/icons/Graduation.png';
import Marriage from '../../../../public/assets/images/icons/Marriage.png';
import Success from '../../../../public/assets/images/icons/Success.png';
import Eid from '../../../../public/assets/images/icons/Eid.png';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';

const PaymentsCards = ({ handlechild, setDataObj, dataObj }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [gifttypesdata, setGifttypesdata] = useState([]);
  const [datanotfound, setDatanotfound] = useState(false);
  const [giftbyid, setGiftbyid] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [lowerSelectedCard, setLowerSelectedCard] = useState(null);

  // ON LOAD FATCH DATA GIFT SERVICE
  useEffect(() => {
    getAsync('GiftService/GetActiveSettingsGiftType').then((res) => {
      setGifttypesdata(res.data);
    });
  }, []);

  // GET GIEFT BY ID
  // projectID
  // giftTypeID
  // giftProjectID

  // console.table(gifttypesdata) done
  // console.log(`niche wala data ${giftbyid}`)

  const icons = [General, Health, Work, Parents, Births, Graduation, Marriage, Success, Eid];

  const onClick = async (e, id) => {
    setDatanotfound(false);
    setLowerSelectedCard(null);
    setIsLoading(true);
    setGiftbyid([]);
    await getAsync(`GiftService/GetGiftProjectByGiftTypeId`, { id: id }).then((response) => {
      if (response) {
        const projectGuid = [];
        response?.data.forEach((item) => {
          // projectGuid.push(item?.projectID);
          projectGuid.push({
            projectID: item?.projectID,
            projectTypeIdInt: item?.projectTypeIdInt,
          });
        });

        const buttons = document.querySelectorAll('.selectbutton');
        buttons.forEach((button) => {
          if (button === e.target) {
            button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');
            const formSection = document.getElementById('form-section');
            if (formSection) {
              formSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              });
            }
          } else {
            button.textContent = t('Select');
          }
        });

        if (response?.statusCode == 204) {
          setIsLoading(false);
          setDatanotfound(true);
        } else {
          handleProjectGUID(projectGuid, id);
        }
      }
      // setGiftbyid(response.data);
      //handlechild(id);
      //setDataObj({ ...dataObj, giftTypeID: id });
    });
  };
  const handleProjectGUID = async (guids, id) => {
    setDatanotfound(false);
    setDataObj({ ...dataObj, giftTypeID: id });
    try {
      const response = await postAsync(`APIClient/ListGUID/`, guids);
      if (response?.data?.length > 0) {
        setGiftbyid(response.data);
        setIsLoading(false);
        setDataObj({ ...dataObj, giftTypeID: id });
        setDatanotfound(false);
      } else if (response?.statusCode == 200 && response?.data?.length == 0) {
          setIsLoading(false);
        setDatanotfound(true);
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleProject = async (e, dataObj, projectID, projectTypeIdInt) => {
    const response = await postAsync(`APIClient/ProjectListGUID `, [
      { ProjectId: projectID, ProjectTypeIdInt: projectTypeIdInt },
    ]);

    setDataObj({
      ...dataObj,
      projectID,
      projectName: response.data[0].titleEn || response.data[0].titleAr,
      projectTypeIdInt: projectTypeIdInt,
    });
    const buttons = document.querySelectorAll('.selectbuttonNested');
    buttons.forEach((button) => {
      if (button === e.target) {
        button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');
        const formSection = document.getElementById('form-section');
        if (formSection) {
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      } else {
        button.textContent = t('Select');
      }
    });
  };

  return (
    <>
      <div className=" flex justify-center pt-12 ">
        <h2 className="text-xl text-black text-center  w-full  font-bold">{t('Gift Types')}</h2>
      </div>
      <div className="flex  flex-wrap py-4 gap-4 justify-center  ">
        {gifttypesdata.map((innerdata, index) => {
          const imageSource = icons[index];
          return (
            <div
              key={index}
              name="ProjecttypeId"
              onClick={(e) => {
                onClick(e, innerdata.giftTypeID);
                setSelectedCard(index);
              }}
              className={` ${selectedCard === index ? 'scale-105 transition-transform duration-300 bg-green-100 shadow-2xl' : 'shadow-md'}  ${isLoading && selectedCard !== index ? 'opacity-50 pointer-events-none  ' : ''} flex flex-col justify-center items-center p-4 gap-2 w-40 max-h-40 cursor-pointer rounded-lg border border-gray-300 dark:bg-gray-50 text-center  transition-colors`}
            >
              <img
                className="w-auto h-24 bg-cover rounded-lg"
                src={imageSource}
                alt={isActive ? innerdata?.ar_SA : innerdata?.en_US} // Use meaningful alt text
              />
              <h5 className="text-xl font-semibold tracking-wide capitalize text-customgreen">
                {isActive ? innerdata?.ar_SA : innerdata?.en_US}
              </h5>

              {/* Uncomment if you need a button */}
              {/* <div className="py-2 px-2">
                <button
                  type="button"
                  name="ProjecttypeId"
                  onClick={(e) => {
                    onClick(e, e.target.value);
                    setSelectedCard(index);
                  }}
                  value={innerdata.giftTypeID}
                  className="selectbutton focus:ring-customgreen py-2.5 text-center w-full rounded-full bg-customgreen text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:bg-hovergreen">
                  {t('Select')}
                </button>
              </div> */}
            </div>
          );
        })}
      </div>

      <div className=" gap-4 p-5">
        {isLoading ? (
          <LoadingAnimation
            imageStyling={''}
            styling={'flex items-center py-5 align-middle justify-center space-x-2'}
          />
        ) : (
          <>
            {giftbyid.length > 0 && (
              <div className=" flex justify-center  ">
                <h2 className="text-xl text-black text-center  w-full  font-bold">{t('Projects')}</h2>
              </div>
            )}

            <div className="flex  flex-wrap gap-4 justify-center pt-10">
              {giftbyid.map((data, index) => {
                return (
                  <>
                    <div>
                      <div
                        key={index}
                        className={`${lowerSelectedCard === index ? 'scale-105 bg-green-50 shadow-2xl' : 'shadow-md'}  block ml-4 mt-4   dark:bg-neutral-700 text-center shadow p-3 mb-5 rounded-3xl`}
                      >
                        <div className="">
                          <h5 className="mb-2 p-4 text-xl tracking-wide  capitalize text-customgreen text-center">
                            {data?.templateName.length > 10
                              ? `${data.templateName.slice(0, 15)}...`
                              : data?.templateName}
                          </h5>
                          <img
                            className="w-full h-32 rounded-t-3xl"
                            src={`data:image/jpeg;base64,${data?.file_Stream ? data?.file_Stream : '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'}`}
                            alt=""
                          />

                          {/* <!-- Button --> */}
                          <button
                            value={data.projectID}
                            onClick={(e) => {
                              handleProject(e, dataObj, data?.id, data?.projectTypeIdInt);
                              setLowerSelectedCard(index);
                            }}
                            className="mt-3 selectbuttonNested focus:ring-customgreen py-2.5 text-center me-1 w-full rounded-full  inline-block  bg-customgreen px-6 pb-2 pt-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-hovergreen hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-customgreen focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-customgreen active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                          >
                            {t('Select')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </>
        )}
        {datanotfound && <DataNotFound />}
      </div>
    </>
  );
};

export default PaymentsCards;
